'use strict';

import mergeOpts from './merge-opts';

export default function SelectorObserver(selector, opts) {

    this.o = mergeOpts({
        existing: true,
    }, opts);

    const listeners = [];
    this.listeners = listeners;

    this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type !== 'childList') {
                return;
            }
            handleNodes('removed', mutation.removedNodes);
            handleNodes('added', mutation.addedNodes);
        });
    });

    if (this.o.existing) {
        handleNodes('added', document.querySelectorAll(selector));
    }

    this.observe();

    function handleNodes(event, nodes) {
        nodes.forEach((node) => {
            if (node instanceof Element) {
                node.matches(selector) && trigger(event, node);
                node.querySelectorAll(selector).forEach((child) => {
                    trigger(event, child);
                });
            }
        });
    }

    function trigger(e, node) {
        listeners.forEach(({event, handler}) => {
            e === event && handler.call(this, node);
        });
    }
}

SelectorObserver.prototype.listen = function (event, handler) {
    this.listeners.push({event: event, handler: handler});
};

SelectorObserver.prototype.unlisten = function (event, handler) {
    for (const index in this.listeners) {
        if (event !== this.listeners[index].event) {
            continue;
        }
        if (handler !== this.listeners[index].handler) {
            continue;
        }
        this.listeners.splice(index, 1);
        break;
    }
};

SelectorObserver.prototype.observe = function () {
    this.observer.observe(document.body, {childList: true, subtree: true});
};

SelectorObserver.prototype.unobserve = function () {
    this.observer.unobserve(document.body);
};